import React, { Component } from 'react';
import './NeighborhoodMap.css';
import ReactMapboxGl, { Layer, Source } from "react-mapbox-gl";
import Buttons from '../Buttons/Buttons.jsx';

const Map = ReactMapboxGl({
    accessToken: "pk.eyJ1IjoibWF4cGxhbmNrLXN0YW1lbiIsImEiOiJjamwybmg5d2oxc2MwM3Buc3NyZHZpeG43In0.-pXSMRxrSkez55nLLEPnGQ"
});

const allVariables = {'superdiversity': {'vancouver': [
    {id: "Ethnic origin (normalized)", name: "Ethnic diversity"},
    {id: "Immigration generation (tertiles)", name: "Immigration generation diversity"},
    {id: "Income deciles (tertiles)", name: "Income diversity"},
    {id: "Education (tertiles)", name: "Education diversity"},
    {id: "Immigration category (tertiles)", name: "Immigration category diversity"},
    {id: "Mobility status 5 years ago (tertiles)", name: "Mobility"}
    ],'auckland': [
    {id: "D_Ethnicity-norm-index", name: "Ethnic diversity"},
    {id: "D_Generation-index", name: "Immigration generation diversity"},
    {id: "D_Income-index", name: "Income diversity"},
    {id: "D_Education-index", name: "Education diversity"},
    {id: "D_Mobility-index", name: "Mobility"}
    ],'sydney': [
    {id: "DIV_Ethn_3", name: "Ethnic diversity"},
    {id: "DIV_Gene_1", name: "Immigration generation diversity"},
    {id: "DIV_Inco_1", name: "Income diversity"},
    {id: "DIV_Educ_1", name: "Education diversity"},
    {id: "DIV_Mobi_1", name: "Mobility"},
    ]
}, 'traditional': {'vancouver': [
    {id: "T_Immigrants", name: "Immigrant population", max: 1.75, min: 0.5},
    {id: "T_Recent immigrants", name: "Recent immigrants", max: 3, min: 0.25},
    {id: "T_South Asian VM", name: "South Asian VM", max: 7},
    {id: "T_Filipino VM", name: "Filipino VM", max: 5},
    {id: "T_Chinese VM", name: "Chinese VM", max: 3.5},
    {id: "T_Top income quintile", name: "High income", max: 2.5, min: 0.25}
], 'auckland': [
    {id: "T_Overseas Born_1", name: "Born overseas", max: 1.75, min: 0.5},
    {id: "T_2011 - 2013_1", name: "Newcomers (2011-2013)", max: 3.5},
    {id: "T_Samoan_1", name: "Samoan ethnicity", max: 5},
    {id: "T_Chinese nfd_1", name: "Chinese ethnicity", max: 5},
    {id: "T_Mäori_1", name: "Mäori ethnicity", max: 4},
    {id: "T_100,000+", name: "High income", max: 5}
], 'sydney': [
    {id: "TRA_Immigr", name: "Immigrant population", max: 2.25, min: 0.5},
    {id: "TRA_Newcom", name: "Newcomers (2011-2016)", max: 5},
    {id: "TRA_Indi_1", name: "Indian ancestry", max: 8},
    {id: "TRA_Ital_1", name: "Italian ancestry", max: 6},
    {id: "TRA_Chin_1", name: "Chinese ancestry", max: 5},
    {id: "TRA_High i", name: "High income", max: 3.5},
]}};

const allLayers = {'vancouver': 'joined-8wldha', 'auckland': 'auckland_2013', 'sydney': ''};
const defaultCenter = {vancouver: [-123.12, 49.23], auckland: [174.76, -36.85], sydney: [151.21, -33.87]};
const defaultZoom = [10];

class Legend extends Component {
    render() {
        let keyClass;
        if (this.props.labels[0] === this.props.labels[1]) {
            keyClass = "hidden";
        } else {
            keyClass = "visible";
        }

        return <div id='key' className={keyClass}>
            <div className="row">
                <div className="sq" style={{backgroundColor: "#c06cba"}}></div>
                <div className="sq" style={{backgroundColor: "#7f679a"}}></div>
                <div className="sq" style={{backgroundColor: "#365f8d"}}></div>
            </div><div className="row">
                <div className="sq" style={{backgroundColor: "#98ade6"}}></div>
                <div className="sq" style={{backgroundColor: "#64a5be"}}></div>
                <div className="sq" style={{backgroundColor: "#459980"}}></div>
            </div><div className="row">
                <div className="sq" style={{backgroundColor: "#add5e9"}}></div>
                <div className="sq" style={{backgroundColor: "#72cbc1"}}></div>
                <div className="sq" style={{backgroundColor: "#4ebc82"}}></div>
            </div>
            <div id="xaxis">{this.props.labels[1].name}</div>
            <div id="yaxis">{this.props.labels[0].name}</div>
        </div>
    }
}

class Controls extends Component {
    render() {
        let active_ids = this.props.active.map((v) => v.id);

        return <div id="controls">
            {this.props.variables.map((v, i) => {
                return <div key={v.id} className={active_ids.indexOf(v.id) >= 0 ? "active" : ""}
                            onClick={() => this.props.callback(i)}>{v.name}</div>;
            })}
        </div>
    }
}

class NeighborhoodMap extends Component {
    constructor(props) {
        super(props);
        this.state = {
            switcher: 0
        }
    }

    updateVariables(newv) {
        if (this.props.mode === 'traditional') {
            this.props.update({variables: [newv, newv]});
            return;
        }

        if (this.state.switcher === 0) {
            this.props.update({variables: [newv, this.props.variables[1]]});
            this.setState({switcher: 1});
        } else {
            this.props.update({variables: [this.props.variables[0], newv]});
            this.setState({switcher: 0});
        }
    }

    shouldComponentUpdate(newProps, newState) {
        if (newProps.mode != this.props.mode) {
            this.props.update({variables: [0, 0]});
            return false;
        }

        if (newProps.variables[0] >= allVariables[newProps.mode][newProps.city].length) {
            this.props.update({variables: [0, this.props.variables[1]]});
            return false;
        }

        if (newProps.variables[1] >= allVariables[newProps.mode][newProps.city].length) {
            this.props.update({variables: [this.props.variables[0], 1]});
            return false;
        }

        return true;
    }

    generatePaint(variables) {
        if (this.props.mode === 'superdiversity') {
            return ["match", ["get", allVariables[this.props.mode][this.props.city][variables[0]].id],
                3, ["match", ["get", allVariables[this.props.mode][this.props.city][variables[1]].id], 1, "#c06cba", 2, "#7f679a", 3, "#365f8d", "#dddddd"],
                2, ["match", ["get", allVariables[this.props.mode][this.props.city][variables[1]].id], 1, "#98ade6", 2, "#64a5be", 3, "#459980", "#dddddd"],
                1, ["match", ["get", allVariables[this.props.mode][this.props.city][variables[1]].id], 1, "#add5e9", 2, "#72cbc1", 3, "#4ebc82", "#dddddd"], "#dddddd"];
        } else {
            return ["interpolate", ["linear"], ["get", allVariables[this.props.mode][this.props.city][variables[0]].id], allVariables[this.props.mode][this.props.city][variables[0]].min || 0, "#add5e9", allVariables[this.props.mode][this.props.city][variables[0]].max, "#365f8d"];
        }
    }

    generateFilter() {
        return ["has", allVariables[this.props.mode][this.props.city][this.props.variables[0]].id];
    }

    updateFilter(newv) {
        this.props.update({mode: newv});
    }

    render() {

        let values = [{display: "Traditional maps", value: "traditional"}, {display: "Superdiversity maps", value: "superdiversity"}];

        return <React.Fragment>
            <Buttons
                values={values}
                callback={this.updateFilter.bind(this)}
                selected={this.props.mode}
              />
            <div id="neighborhoodmap">
            <Legend
                labels={this.props.variables.map(i => allVariables[this.props.mode][this.props.city][i])} />
            <Controls
                variables={allVariables[this.props.mode][this.props.city]}
                callback={this.updateVariables.bind(this)}
                active={this.props.variables.map(i => allVariables[this.props.mode][this.props.city][i])} />
            <Map
                style="mapbox://styles/maxplanck-stamen/cjnowwcfw1o3j2rrqmvok7dj6"
                center={defaultCenter[this.props.city]}
                zoom={defaultZoom}
                minZoom={6}
                containerStyle={{
                    height: "750px",
                    width: "100%"
                }}>
                <Source
                    id="vancouver"
                    key="vancouver"
                    geoJsonSource={{type: "vector", url: "mapbox://maxplanck-stamen.5b30bhw9"}}
                />
                <Source
                    id="auckland"
                    key="ackland"
                    geoJsonSource={{type: "vector", url: "mapbox://maxplanck-stamen.1z7fdc7l"}}
                />
                <Source
                    id="sydney"
                    key="sydney"
                    geoJsonSource={{type: "vector", url: "mapbox://maxplanck-stamen.bu9i8mky"}}
                />
                <Layer
                    id="data-fill-vancouver"
                    sourceId="vancouver"
                    type="fill"
                    sourceLayer="joined_w_trad-7ro5de"
                    filter={this.generateFilter()}
                    paint={{
                        'fill-color': this.generatePaint(this.props.variables),
                        'fill-opacity': 0.8
                    }}
                    before="waterway-river-canal"
                ></Layer>
                <Layer
                    id="data-fill-sydney"
                    sourceId="sydney"
                    type="fill"
                    sourceLayer="sydney"
                    filter={this.generateFilter()}
                    paint={{
                        'fill-color': this.generatePaint(this.props.variables),
                        'fill-opacity': 0.8
                    }}
                    before="waterway-river-canal"
                ></Layer>
                <Layer
                    id="data-fill-auckland"
                    sourceId="auckland"
                    type="fill"
                    sourceLayer="auckland_simplified"
                    filter={this.generateFilter()}
                    paint={{
                        'fill-color': this.generatePaint(this.props.variables),
                        'fill-opacity': 0.8
                    }}
                    before="waterway-river-canal"
                ></Layer>
            </Map>
        </div>
        </React.Fragment>
    }
}

export default NeighborhoodMap;



// WEBPACK FOOTER //
// ./src/NeighborhoodMap/NeighborhoodMap.js